window.trackGA4 = function (element, key, overrideValues) {
    // Helper function to clean text: remove question marks, exclamation marks, and accent characters
    function cleanText(text) {
        if (!text || typeof text !== "string") {
            return text;
        }
        // Remove question marks and exclamation marks
        text = text.replace(/[?!]/g, "");
        // Remove accent characters by normalizing to NFD (decomposed form) and removing combining diacritical marks
        text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return text;
    }

    if (typeof element !== "object") {
      element = {}
    }
    if (element === null) {
      element = {}
    }
    if (typeof element.innerText !== "string") {
      element.innerText = ""
    }
    if (typeof element.getAttribute !== "function") {
      element.getAttribute = function () {
        return ""
      }
    }

    var event = {};
    var linkType = null;
    if (element.href) {
      if (element.href.indexOf("mailto:") === 0) {
        linkType = "email";
      } else if (element.href.indexOf("cookie") !== -1 || element.innerText.toLowerCase().indexOf("cookie") !== -1) {
        linkType = "cookie";
      } else if (element.getAttribute("target") === "_blank") {
        linkType = "exit";
      }
    }

    switch (key) {
      case "globalnav_link":
        event = {
            "event": "ga4_custom_link",
            "link_location": "header",
            "link_text": cleanText(element.innerText || element.getAttribute("aria-label") || element.getAttribute("title")),
            "link_item": "navclick",
            "link_detail": null,
            "link_action": null,
            "link_display": element.innerText.length > 0 ? "text" : "image",
            "link_position": null,
            "link_conversion": 0,
            "link_type": linkType,
            "component_name": "globalnav",
            "link_url": element.href
        }
        break;
      case "burger_menu_click":
        event = {
            "event": "ga4_custom_link",
            "link_location": "header",
            "link_text": "menu",
            "link_action":element.classList.contains('collapsed') ? "expand" : "collapse",
            "link_detail": null,
            "link_display": "image",
            "link_position": null,
            "link_conversion": 0,
            "link_type": null,
            "component_name": "globalnav",
            "link_url": "" 
        }
        break;
      case "dynamic_link":
        // Determine link_display based on element type/class
        var linkDisplay;
        if (element.tagName === "BUTTON" || (element.classList && element.classList.contains("cta"))) {
            linkDisplay = "button";
        } else {
            linkDisplay = element.innerText.length > 0 ? "text" : "image";
        }
        
        // Determine link_type based on target attribute (linkType already handles this, but ensure it's set)
        var dynamicLinkType = linkType;
        if (!dynamicLinkType && element.getAttribute("target") === "_blank") {
            dynamicLinkType = "exit";
        }
        
        // Determine component_name from closest section parent's first h1 if not provided in overrideValues
        var componentName = null;
        if (!overrideValues || overrideValues.component_name === undefined) {
            var currentElement = element;
            var sectionParent = null;
            
            // Find closest section parent
            while (currentElement && currentElement.parentElement) {
                currentElement = currentElement.parentElement;
                if (currentElement.tagName === "SECTION") {
                    sectionParent = currentElement;
                    break;
                }
            }
            
            // If section found, look for first h1
            if (sectionParent) {
                var h1Element = sectionParent.querySelector("h1");
                if (h1Element && h1Element.innerText) {
                    componentName = cleanText(h1Element.innerText.trim());
                }
            }
        }
        
        // Build base event object with defaults and element-derived values
        // overrideValues can override any of these defaults
        event = {
            "event": "ga4_custom_link",
            "link_location": (overrideValues && overrideValues.link_location !== undefined) ? overrideValues.link_location : null,
            "link_text": (overrideValues && overrideValues.link_text !== undefined) ? cleanText(overrideValues.link_text) : cleanText(element.innerText || ""),
            "link_item": (overrideValues && overrideValues.link_item !== undefined) ? overrideValues.link_item : null,
            "link_action": (overrideValues && overrideValues.link_action !== undefined) ? overrideValues.link_action : null,
            "link_detail": (overrideValues && overrideValues.link_detail !== undefined) ? overrideValues.link_detail : null,
            "link_description": (overrideValues && overrideValues.link_description !== undefined) ? overrideValues.link_description : null,
            "link_display": (overrideValues && overrideValues.link_display !== undefined) ? overrideValues.link_display : linkDisplay,
            "link_position": (overrideValues && overrideValues.link_position !== undefined) ? overrideValues.link_position : null,
            "link_conversion": (overrideValues && overrideValues.link_conversion !== undefined) ? overrideValues.link_conversion : 0,
            "link_type": (overrideValues && overrideValues.link_type !== undefined) ? overrideValues.link_type : dynamicLinkType,
            "component_name": (overrideValues && overrideValues.component_name !== undefined) ? overrideValues.component_name : componentName,
            "link_url": (overrideValues && overrideValues.link_url !== undefined) ? overrideValues.link_url : (element.href || "")
        };
        break;
      case "custom_page_view":
        event = {
            "event": "custom_page_view"
        };
        break;
      default:
        return;
    }

    if (window.location.origin === "http://localhost:3000") {
      window.console.log("event", event);
    }

    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer != "undefined") {
      window.dataLayer.push(event);
    }
}


document.addEventListener('DOMContentLoaded', function() {
  const navLinks = document.querySelectorAll('.navbar-default a');
  const mobileMenu = document.getElementById('mobilemenu');

  mobileMenu.addEventListener('click', function() {
    trackGA4(mobileMenu, 'burger_menu_click');
  });

  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      trackGA4(link, 'globalnav_link');
    });
  });
});
